import {
    SALES_REQUEST_START,
    SALES_REQUEST_SUCCESS,
    SALES_REQUEST_FAILED,
    SALES_REQUEST_NO_PERMISSION
}
    from '../actions/SalesActions';

const initialState = {
    status:'Initialize',
};

export default function SalesReducer(state = initialState, action) {

    if (!action){
        return state;
    }

    switch (action.type) {
        case SALES_REQUEST_START:
            return {...state, status:'request'};
        case SALES_REQUEST_SUCCESS:
            return {...state, status:'success',data: action.data};
        case SALES_REQUEST_NO_PERMISSION:
            return {...state, status:'no_permission'};
        case SALES_REQUEST_FAILED:
            return {...state, status:'error'};
        default:
            return state;
    }
}
